import * as React from "react";

import { Message } from "@/shared/reader";

import { RenderingError } from "../RenderingError";

import styles from "./FormattedMessage.module.css";

const JsonTreeView = React.lazy(
  () => import("@/shared/components/JsonTreeView/JsonTreeView"),
);

interface FormattedMessageProps {
  error: Error | null;
  message: Message | null;
}

export function FormattedMessage({ error, message }: FormattedMessageProps) {
  if (error !== null) {
    return <RenderingError error={error} />;
  }

  // Keep mounted (hide via display:none) so the user's expanded-node state
  // in react-json-view survives playhead ticks — unmounting collapses the
  // tree on every message change.
  const noMessage = message === null;

  return (
    <div
      className={`ph-no-capture ${styles.message}`}
      style={{ display: noMessage ? "none" : undefined }}
    >
      <React.Suspense fallback={null}>
        <JsonTreeView src={message ?? {}} />
      </React.Suspense>
    </div>
  );
}
